import Consult from './Consult'
import ConsultPolicy from './ConsultPolicy'

export default {
  Consult,
  ConsultPolicy,
}
